<template>
  <span class="carStatus123" :style="{ background: color[realTimeStatus] }">{{
    carStatue[realTimeStatus]
  }}</span>
</template>
<script>
export default {
  props: ["realTimeStatus"],
  data() {
    return {
      carStatue: {
        1: "离线",
        2: "停车",
        3: "行驶",
        4: "停留",
        5: "维修",
        6: "报废",
      },
      color: {
        1: "#838383",
        2: "#eb8c39",
        3: "#20be36",
        4: "#3a99ed",
        5: "#ff2727",
        6: "#515151",
      },
    };
  },
};
</script>
<style lang="">
.carStatus123 {
  color: #fff;
  font-size: 12px !important;
  font-weight: bold;
  padding: 1px 4px;
  line-height: 12px;
  position: relative;
  top: -2px;
  border-radius: 8px;
  background: #1379ee;
}
</style>


// WEBPACK FOOTER //
// src/components/common/carStatue.vue